/* projects/shared/src/lib/components/idba-mat-table-footer/idba-mat-table-footer.scss */
::ng-deep .mat-mdc-footer-cell {
  -webkit-text-stroke-width: medium;
}
.currency {
  text-align: right !important;
  justify-content: right !important;
  align-items: end !important;
}
/*# sourceMappingURL=idba-mat-table-footer.css.map */
